import { Icon, iconSizes } from "@hubrise/react-components"
import styled from "styled-components"

import { clickableRoundIcon } from "shared/styles/common"

export const StyledTopbar = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: 1.5rem;
`

export const Main = styled.div`
  flex-grow: 1;
`

export const Icons = styled.div`
  margin-top: 0.25rem;
  display: flex;
`

export const TopbarIcon = styled(Icon).attrs({ size: iconSizes._20 })`
  margin-left: 0.5rem;
  ${clickableRoundIcon};
`
